import React from 'react';
import { graphql, Link } from 'gatsby';
import { useIntl } from 'gatsby-plugin-intl';

const TagTemplate = ({ data, pageContext }) => {
  const tag = pageContext.tag;
  const posts = data.allMarkdownRemark.nodes;
  const intl = useIntl(); // Récupérez la langue actuelle de la page

  return (
    <div>
      <h1>Articles avec le tag "{tag}"</h1>
      <ul>
        {posts
          .filter((post) => post.frontmatter.lang === intl.locale) // Filtrez les articles par langue
          .map((post) => (
            <li key={post.fields.slug}>
              <Link to={post.fields.slug}>{post.frontmatter.title}</Link>
            </li>
          ))}
      </ul>
    </div>
  );
};

export const query = graphql`
  query ($tag: String!) {
    allMarkdownRemark(
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      nodes {
        fields {
          slug
        }
        frontmatter {
          title
          lang
        }
      }
    }
  }
`;

export default TagTemplate;
